import { render, staticRenderFns } from "./EditRequestList.vue?vue&type=template&id=6c3a9316"
import script from "./EditRequestList.vue?vue&type=script&lang=js"
export * from "./EditRequestList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports